import { configureStore } from '@reduxjs/toolkit';
import periodReducer from './slices'; 
import categoryReducer from '../Redux/CategorySlice'; 

const store = configureStore({
  reducer: {
    period: periodReducer,
    category: categoryReducer
  }
});

export default store;
